import * as React from 'react';
import { Field, change } from 'redux-form';
import { get } from 'lodash';

import KeyboardArrowDown from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import Clear from 'material-ui/svg-icons/content/clear';
import { FormAutoComplete } from '@inqool/uas-web-core/es/components/controls/AutoComplete';
import muiThemeable from 'material-ui/styles/muiThemeable';

import * as T from '@components/form/AutoComplete/_autoCompleteTypes';

const defaultArrowStyle = (withLabel: boolean): React.CSSProperties => ({
  color: '#00000080',
  position: 'absolute',
  right: 0,
  top: withLabel ? 36 : 15
});

const defaultClearStyle = (withLabel: boolean): React.CSSProperties => ({
  color: '#00000080',
  position: 'absolute',
  right: 24,
  top: withLabel ? 36 : 15,
  cursor: 'pointer'
});

class AutoComplete extends React.Component<T.OutterProps, T.AutoCompleteState> {
  state: T.AutoCompleteState = {
    filterType: ''
  };
  node: any = null;
  myRef = node => {
    this.node = node;
  };
  handleDelete = async () => {
    const { meta, onDelete, input } = this.props;
    const { dispatch, form } = meta;

    if (onDelete) {
      await onDelete();
    }

    dispatch(change(form, input.name, ''));
  };
  openAutocomplete = () => {
    if (this.props.disabled) {
      return;
    }
    if (this.state.filterType === '' && this.node) {
      this.node.focus();
      this.setState({ filterType: 'all' });
    } else {
      this.setState({ filterType: '' });
    }
  };
  onClick = () => this.setState({ filterType: '' });
  render() {
    return (
      <div style={{ position: 'relative', width: '100%' }}>
        <FormAutoComplete
          {...this.props}
          inputRef={this.myRef}
          fullWidth={true}
          floatingLabelText={this.props.label}
          onClick={this.onClick}
          filter={(searchText, key) => {
            const normalize = str =>
              (str || '')
                .toString()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase();
            const normalizedSearchText = normalize(searchText);
            const normalizedKey = normalize(key);
            return normalizedKey.includes(normalizedSearchText);
          }}
        />
        <KeyboardArrowDown
          style={{
            ...(this.props.arrowstyle || defaultArrowStyle(!!this.props.label)),
            color: get(this.props, 'muiTheme.palette.disabledColor')
          }}
          onClick={this.openAutocomplete}
        />
        {!this.props.disabled &&
          this.props.input.value && (
            <Clear
              onClick={this.handleDelete}
              style={{
                ...defaultClearStyle(!!this.props.label),
                color: get(this.props, 'muiTheme.palette.disabledColor')
              }}
            />
          )}
      </div>
    );
  }
}

export default muiThemeable()(AutoComplete);

export class AutoCompleteField extends Field<T.OutterCustomProps> {}



// WEBPACK FOOTER //
// ./src/components/form/AutoComplete/AutoComplete.tsx